import styles from '../../../Result/IacstResults/iacstResults.module.css'
const ResultTable = (props) => {
    const { data } = props

    return (
        <>
            <div className={styles.tableWrapper}>
                <div style={{ minWidth: '315px' }}>
                    <header className={styles.header}>RESULT</header>
                    <main className={styles.header2}>{props.classname}</main>
                    <section className={styles.section}>
                        <div className={styles.secData}>
                            <span className={styles.spanA}>Roll No. / PSID</span> :
                            <span className={styles.spanB}>
                                <b>
                                    {data?.result.rollno}
                                    {` / `}
                                    {data?.result.PSID}
                                </b>
                            </span>
                        </div>

                        <div className={styles.secData}>
                            <span className={styles.spanA}>
                                Name of the Candidate
                            </span>{' '}
                            :
                            <span className={styles.spanB}>{data?.result.Name}</span>
                        </div>

                        <div className={styles.secData}>
                            <span className={styles.spanA}>Father's Name</span> :
                            <span className={styles.spanB}>
                                {data?.result.Fname}
                            </span>
                        </div>

                        <div className={styles.secData}>
                            <span className={styles.spanA}>
                                Stream / Class Opted{' '}
                            </span>{' '}
                            :
                            <span
                                className={styles.spanB}
                                style={{ wordBreak: 'break-word' }}
                            >{`${data?.result.stream} / ${data?.result.ClassOpted}`}</span>
                        </div>
                        {props?.data.result?.OverallScorePercentage ? (
                            <div className={styles.secData}>
                                <span className={styles.spanA}>
                                    Percentage Marks{' '}
                                </span>{' '}
                                :
                                <span className={styles.spanB}>
                                    {props?.data.result?.OverallScorePercentage}%
                                </span>
                            </div>
                        ) : (
                            <></>
                        )}
                        <div className={styles.secData}>
                            <span className={styles.spanA}>iACST Result </span> :
                            <span
                                className={styles.spanB}
                                style={{ wordBreak: 'break-word' }}
                            >
                                {data?.result?.Status}
                                {props.result}
                                {data?.result?.Status == 'Qualified' ? (
                                    <span>
                                        * |{' '}
                                        {props?.data.result?.ScholarshipPercentage}%
                                        Waiver on Tuition & Classroom Service Fee
                                        based on your IACST 2024 Percentage Score.
                                    </span>
                                ) : (
                                    ''
                                )}
                            </span>
                        </div>
                    </section>
                </div>
            </div>
            {data?.result.Status == 'Qualified' ? (
                <div className={styles.qualifiedText}>
                    *The secured scholarship is applicable on Classroom Courses
                </div>
            ) : (
                <div className={styles.qualifiedText}></div>
            )}
        </>
    )
}

export default ResultTable
